import { render, staticRenderFns } from "./detailTenderDocument.vue?vue&type=template&id=7a632193&scoped=true&"
import script from "./detailTenderDocument.vue?vue&type=script&lang=js&"
export * from "./detailTenderDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a632193",
  null
  
)

export default component.exports